import { render } from "./ComposeModal.vue?vue&type=template&id=7637d976"
import script from "./ComposeModal.vue?vue&type=script&lang=js"
export * from "./ComposeModal.vue?vue&type=script&lang=js"

import "./ComposeModal.vue?vue&type=style&index=0&id=7637d976&lang=css"

import exportComponent from "/home/forge/staging.ordinocrm.com/releases/20260610000542/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__